import { memo } from 'react'

import { PUBLIC_COMMIT_SHA } from '@lib/constants'

export const GitSha = memo(() => (
  <span className='fixed top-0 z-50 right-1/2 translate-x-1/2 text-[8px] h-[8px] text-transparent hover:text-muted-foreground cursor-default transition-all duration-1000'>
    {PUBLIC_COMMIT_SHA}
  </span>
))
